import './swiperCard.scss';

import { Link } from 'react-scroll';

interface AnimeProps {
    image: string,
    title: string,
    description: string
}

export default function SwiperCard(props: AnimeProps) {
    const clean = props.title.replace(/!|\?/g, '');

    return (
        <div className='card'>
            <div className="image">
                <img src={ props.image } alt={ props.title }/>
                <div className="overlay-color"/>
            </div>
            <div className="information">
                <Link smooth={ true } to={ clean } style={{ cursor: 'pointer' }}>
                    <h1 title={ props.title } className='title'>{props.title}</h1>
                </Link>
                <p>{props.description}</p>
            </div>
        </div>
    );
};